import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  BarChart,
  Bar,
} from 'recharts';

import { DashboardLayout } from '@/components/dashboard/DashboardLayout';
import { PageHeader } from '@/components/dashboard/PageHeader';
import { participationsTrend, cityBreakdown, fmt } from '@/lib/mockData';

const PartenaireStats = () => (
  <DashboardLayout
    role="partenaire"
    user={{ name: 'Marie Koné', subtitle: 'Orange CI', initials: 'MK' }}
  >
    <PageHeader title="Statistiques" subtitle="Analyse fine de l'engagement et de la conversion." />

    <div className="grid gap-6 lg:grid-cols-2">
      <div className="rounded-2xl border border-border bg-card p-6 shadow-soft">
        <h3 className="font-display text-lg font-bold">Tendance participations</h3>
        <p className="text-xs text-muted-foreground">14 derniers jours.</p>
        <div className="mt-4 h-64">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={participationsTrend} margin={{ left: 0, right: 8, top: 8, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
              <XAxis
                dataKey="day"
                stroke="hsl(var(--muted-foreground))"
                fontSize={11}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                stroke="hsl(var(--muted-foreground))"
                fontSize={11}
                tickLine={false}
                axisLine={false}
              />
              <Tooltip
                contentStyle={{
                  background: 'hsl(var(--card))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: 12,
                  fontSize: 12,
                }}
              />
              <Line
                type="monotone"
                dataKey="participations"
                stroke="hsl(var(--primary))"
                strokeWidth={2.5}
                dot={false}
              />
              <Line
                type="monotone"
                dataKey="gains"
                stroke="hsl(var(--accent))"
                strokeWidth={2.5}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="rounded-2xl border border-border bg-card p-6 shadow-soft">
        <h3 className="font-display text-lg font-bold">Répartition par ville</h3>
        <p className="text-xs text-muted-foreground">% des participations totales.</p>
        <div className="mt-4 h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={cityBreakdown}
              layout="vertical"
              margin={{ left: 0, right: 16, top: 8, bottom: 0 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" horizontal={false} />
              <XAxis
                type="number"
                stroke="hsl(var(--muted-foreground))"
                fontSize={11}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                dataKey="city"
                type="category"
                width={80}
                stroke="hsl(var(--muted-foreground))"
                fontSize={12}
                tickLine={false}
                axisLine={false}
              />
              <Tooltip
                contentStyle={{
                  background: 'hsl(var(--card))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: 12,
                  fontSize: 12,
                }}
              />
              <Bar dataKey="value" radius={[0, 8, 8, 0]} fill="hsl(var(--primary))" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>

    <div className="mt-6 grid gap-4 sm:grid-cols-3">
      {[
        { label: 'Coût par lead', value: '180 FCFA' },
        { label: 'Taux de conversion', value: fmt.pct(68) },
        { label: 'Partages sociaux', value: '12,4 K' },
      ].map(s => (
        <div key={s.label} className="rounded-2xl border border-border bg-card p-5 shadow-soft">
          <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
            {s.label}
          </p>
          <p className="mt-2 font-display text-2xl font-extrabold">{s.value}</p>
        </div>
      ))}
    </div>
  </DashboardLayout>
);

export default PartenaireStats;
